export class User {
  constructor(
    public id: number | null,
    public name: string,
    public displayname: string,
    public email: string,
    public supervisor: boolean,
    public active: boolean
  ) {
    this.id = id;
    this.name = name;
    this.displayname = displayname;
    this.email = email;
    this.supervisor = supervisor;
    this.active = active;
  }
  public static get EMPTY(): User {
    return new User(null, "", "", "", false, false);
  }
  hasValidDisplayName(): boolean {
    return !!this.displayname && this.displayname.trim().length > 0;
  }
}
